<template>
  <v-dialog
    v-model="dialog"
    max-width="400"
    @click:outside="cancel"
    content-class="rounded-lg"
  >
    <v-card>
      <v-card-title> Compartilhar Ingresso </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="name"
          label="Nome de quem usará o ingresso"
          outlined
          dense
          autofocus
          :disabled="forMe || isCourtesy"
          :rules="[
            (v) => !!v || 'Nome é obrigatório',
            (v) => v.length > 2 || 'Nome deve ter mais de 2 caracteres',
          ]"
        />
        <v-checkbox
          v-model="forMe"
          label="Eu vou usar o ingresso"
          dense
          :disabled="isCourtesy"
        />

        <v-alert
          v-if="ticket?.TicketShare?.length > 0"
          type="warning"
          text
          dense
        >
          <b>Atenção!</b> Esse ingresso já foi compartilhado antes.
          <br />
          <span>Compartilhado com:</span>
          <v-list color="transparent">
            <v-list-item
              v-for="share in ticket?.TicketShare"
              :key="share.id"
              class="warning--text px-0"
            >
              <v-list-item-content class="py-0">
                <v-list-item-title class="font-weight-bold text-15">
                  {{ share.name }}: {{ share.phone }}
                </v-list-item-title>
                <v-list-item-subtitle class="warning--text text-13">
                  {{ share.createdAt | date("DD/MM/YYYY HH:mm") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-alert>
        <v-alert v-else type="info" text>
          Salvaremos esses dados para ajudar você a saber quem recebeu cada
          ingresso
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="cancel"> Cancelar </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          @click="close"
          :disabled="(!name || name.length < 3) && !forMe"
        >
          Continuar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      name: "",
      ticket: null,
      promise: null,
      forMe: false,
      isCourtesy: false,
    };
  },
  methods: {
    open(ticket) {
      this.dialog = true;
      this.name = "";
      this.ticket = ticket;
      const isCourtesy = ticket.Payment?.paymentType === "COURTESY";
      this.isCourtesy = isCourtesy;
      this.forMe = isCourtesy;
      return new Promise((resolve, reject) => {
        this.promise = { resolve, reject };
      });
    },
    close() {
      this.dialog = false;
      this.promise.resolve(this.forMe || this.name);
    },
    cancel() {
      this.dialog = false;
      this.promise.resolve(null);
    },
  },
};
</script>
